/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-divider-margin-inset: Divider margin inset
 * @prop --sy-divider-border-color: Divider border color
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: block;
  border-color: var(--sy-divider-border-color, var(--sy-border));
  border-style: solid;
  border-width: 1px 0 0;
}

:host([type=inset]) {
  margin-right: var(--sy-divider-margin-inset, var(--sy-spacer-3));
  margin-left: var(--sy-divider-margin-inset, var(--sy-spacer-3));
}

:host([type=vertical]) {
  width: 1px;
  height: 100%;
  border-width: 0 1px 0 0;
}